import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { WithdrawKaudiPage } from "./withdraw-kaudi.page";

const routes: Routes = [
  {
    path: "",
    component: WithdrawKaudiPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
  ],
  declarations: [WithdrawKaudiPage],
})
export class WithdrawKaudiPageModule {}
